/**
 * Аналог isInstanceOf для клиентских импортов (first, each, exists, …).
 */
export function platformIsInstanceOf(obj: unknown, ctor: unknown): boolean {
  if (obj == null || ctor == null) return false

  if (
    ctor != null &&
    typeof ctor === 'object' &&
    (ctor as { __platformIterableMarker?: boolean }).__platformIterableMarker === true
  ) {
    return (
      typeof obj === 'object' &&
      obj !== null &&
      typeof (obj as { iterator?: unknown }).iterator === 'function'
    )
  }

  if (ctor === Array) return Array.isArray(obj)

  if (ctor === String) return typeof obj === 'string' || obj instanceof String

  if (ctor === Number) return typeof obj === 'number' || obj instanceof Number
  if (ctor === Boolean) return typeof obj === 'boolean' || obj instanceof Boolean
  if (ctor === Function) return typeof obj === 'function'

  if (typeof ctor === 'function') {
    try {
      return obj instanceof (ctor as new (...args: unknown[]) => object)
    } catch {
      return false
    }
  }

  return false
}
